export default "__VITE_ASSET__Diq4x0h2__"